// extracted by mini-css-extract-plugin
module.exports = {"station":"_14524","afterSalesDesc":"_16149","title":"_5798","arrow":"_10189"};